/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateRegistrazioneDto } from '../../models/create-registrazione-dto';
import { RegistrazioneResDto } from '../../models/registrazione-res-dto';

export interface RegistrazioniControllerCreateContratti$Params {
  body: CreateRegistrazioneDto;
}

export function registrazioniControllerCreateContratti(
  http: HttpClient,
  rootUrl: string,
  params: RegistrazioniControllerCreateContratti$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<RegistrazioneResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    registrazioniControllerCreateContratti.PATH,
    'post',
  );
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RegistrazioneResDto>;
      }),
    );
}

registrazioniControllerCreateContratti.PATH = '/admin/registrazione';
